export const analyticsCustomersThunkNames = {
    fetchAnalyticsCustomers: 'fetchAnalyticsCustomers',
    updateAnalyticsCustomers: 'updateAnalyticsCustomers',
};
